import { useEffect, useState } from "react";
import { useApiClient } from "../../../hooks/useApiClient";
import { getHomeDashboardInfo } from "../../../services/homeService";
import { IHomeDashboardResponse } from "../Interfaces/IHomeInterface";

export function useHomeDashboard() {
  const { call, ready } = useApiClient();
  const [data, setData] = useState<IHomeDashboardResponse | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    if (!ready) return;

    (async () => {
      setLoading(true);
      setError(null);
      try {
        const result = await call<IHomeDashboardResponse>(getHomeDashboardInfo);
        setData(result);
      } catch (err) {
        setError(err as Error);
      } finally {
        setLoading(false);
      }
    })();
  }, [ready]);

  return { data, loading, error };
}
